export interface CategoryComboModel {
  id: number;
  nome: string;
}

export function categoryComboDataToValues(data?: CategoryComboModel[]) {
  return (
    data?.map((item) => ({
      id: item.id,
      label: item.nome,
    })) ?? []
  );
}
